import React, { useState } from 'react';
import GeofenceLogin from './GeofenceLogin';
import ServiceLogin from './ServiceLogin';
import { useBackClose } from './backButton';
import './LoginPage.css';

const LoginPage = ({ onDemoLogin, onGuestLogin, language, setLanguage }) => {
  const [showEgovAuth, setShowEgovAuth] = useState(false);
  const [showGeofenceLogin, setShowGeofenceLogin] = useState(false);
  const [showServiceLogin, setShowServiceLogin] = useState(false);

  // Кнопка «Назад»: возврат со страницы входа на стартовую страницу
  useBackClose(showGeofenceLogin, () => setShowGeofenceLogin(false));
  useBackClose(showServiceLogin, () => setShowServiceLogin(false));
  useBackClose(showEgovAuth, () => setShowEgovAuth(false));

  const translations = {
    kk: {
      title: 'Тұрғын',
      subtitle: 'Житель',
      description: 'Алтай қаласының оқиғаларды басқару жүйесі',
      authTitle: 'Жүйеге кіру',
      egovAuth: 'eGov Mobile / Digital ID арқылы кіру',
      mobileId: 'Mobile ID',
      digitalId: 'Digital ID (Face ID)', 
      digitalSignature: 'ЭЦП (электрондық қолтаңба)',
      registerButton: 'Тіркелу',
      loginButton: 'Жүйеге кіру',
      demoMode: 'Демо режимі',
      guestMode: 'Қонақ режимі',
      guestDescription: 'Оқиғаларды тек қарау үшін',
      comingSoon: 'eGov интеграциясы демонстрациядан кейін қосылады',
      backButton: '← Кіруді таңдауға оралу',
      residentButton: '👤 Алтай қаласының тұрғыны',
      serviceButton: '🏛️ Қала қызметі',
      residentDescription: '👤 Тұрғын: Алтай қаласындағы геопозиция бойынша автоматты кіру',
      serviceDescription: '🏛️ Қызмет: Қызметтік кілт арқылы кіру (қызмет қызметкерлері және Әкім үшін)'
    },
    ru: {
      title: 'Тұрғын',
      subtitle: 'Житель', 
      description: 'Система управления событиями города Алтай',
      authTitle: 'Вход в систему',
      egovAuth: 'Войти через eGov Mobile / Digital ID',
      mobileId: 'Mobile ID',
      digitalId: 'Digital ID (Face ID)',
      digitalSignature: 'ЭЦП (электронная подпись)',
      registerButton: 'Зарегистрироваться',
      loginButton: 'Войти в систему',
      demoMode: 'Демо режим',
      guestMode: 'Гостевой режим',
      guestDescription: 'Только для просмотра событий',
      comingSoon: 'Интеграция с eGov будет добавлена после демонстрации',
      backButton: '← Назад к выбору входа',
      residentButton: '👤 Житель города Алтай',
      serviceButton: '🏛️ Служба города',
      residentDescription: '👤 Житель: Автоматический вход по геопозиции в городе Алтай',
      serviceDescription: '🏛️ Служба: Вход по служебному ключу (для сотрудников служб и Акима)'
    }
  };

  const t = translations[language];

  const handleGeofenceSuccess = (authData) => {
    // Устанавливаем небольшую задержку перед перезагрузкой для сохранения данных
    setTimeout(() => {
      window.location.reload(); // Перезагружаем приложение для применения auth токена
    }, 100);
  };

  const handleGeofenceError = (error) => {
    console.error('Geofence login error:', error);
    alert((language === 'kk' ? 'Геоаймақ арқылы кіру қатесі: ' : 'Ошибка входа через геозону: ') + error.message);
  };

  const handleServiceSuccess = (authData) => {
    // Устанавливаем небольшую задержку перед перезагрузкой для сохранения данных
    setTimeout(() => {
      window.location.reload(); // Перезагружаем приложение для применения auth токена
    }, 100);
  };

  const handleServiceError = (error) => {
    console.error('Service login error:', error);
    alert((language === 'kk' ? 'Қызмет арқылы кіру қатесі: ' : 'Ошибка входа службы: ') + error.message);
  };

  // Показываем геозону если выбран этот режим
  if (showGeofenceLogin) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <div className="login-logo">
              <img src="/logo.jpg" alt="Алтай Логотип" />
            </div>
            <div className="login-title">
              <h1>{t.title}</h1>
              <h2>{t.subtitle}</h2>
            </div>
          </div>

          <GeofenceLogin 
            onSuccess={handleGeofenceSuccess}
            onError={handleGeofenceError}
            language={language}
          />

          <button 
            className="back-button"
            onClick={() => setShowGeofenceLogin(false)}
          >
            {t.backButton}
          </button>
        </div>
      </div>
    );
  }

  // Показываем вход для служб если выбран этот режим
  if (showServiceLogin) {
    return (
      <div className="login-page">
        <div className="login-container">
          <div className="login-header">
            <div className="login-logo">
              <img src="/logo.jpg" alt="Алтай Логотип" />
            </div>
            <div className="login-title">
              <h1>{t.title}</h1>
              <h2>{t.subtitle}</h2>
            </div>
          </div>

          <ServiceLogin 
            onSuccess={handleServiceSuccess}
            onError={handleServiceError}
            onBack={() => setShowServiceLogin(false)}
            language={language}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="login-container">
        {/* Logo and Title */}
        <div className="login-header">
          <div className="login-logo">
            <img src="/logo.jpg" alt="Алтай Логотип" />
          </div>
          <div className="login-title">
            <h1>{t.title}</h1>
            <h2>{t.subtitle}</h2>
          </div>
        </div>

        <div className="login-description">
          <p>{t.description}</p>
        </div>

        {/* Language Switcher */}
        <div className="language-switcher-login">
          <button 
            className={language === 'kk' ? 'active' : ''}
            onClick={() => setLanguage('kk')}
          >
            ҚАЗ
          </button>
          <button 
            className={language === 'ru' ? 'active' : ''}
            onClick={() => setLanguage('ru')}
          >
            РУС
          </button>
        </div>

        {/* Authentication Section */}
        <div className="auth-section">
          <h3>{t.authTitle}</h3>
          
          <div className="main-auth-buttons">
            {/* Кнопка для жителей - вход по геопозиции */}
            <button 
              className="resident-button"
              onClick={() => setShowGeofenceLogin(true)}
            >
              {t.residentButton}
            </button>
            
            {/* Кнопка для служб и Акима - вход по ключу */}
            <button 
              className="service-button"
              onClick={() => setShowServiceLogin(true)}
            >
              {t.serviceButton}
            </button>
          </div>
          
          <div className="auth-description">
            <div className="auth-option">
              {t.residentDescription}
            </div>
            <div className="auth-option">
              {t.serviceDescription}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;